<template>
  <ul>
    <li v-for="item in value" :key="item.value">
      <input
        type="radio"
        :value="item.value"
        :name="item.name"
        :id="item.value"
        @click="onSelected(item.value)"
        :checked="item.value == isDefault"
        v-focus
      />
      <label :for="item.value">{{ item.label }}</label>
      <div class="check"></div>
    </li>
  </ul>
</template>

<script>
export default {
  props: ["label", "name", "value", "isDefault"],
  methods: {
    onSelected(val) {
      this.$emit("clicked", val);
    },
  },
};
</script>

<style lang="scss" scoped>
$animationDuration: 0.5s; // specify animation duration. Default value: 1s
@import "../sass/vue2-animate.scss";

ul li {
  color: #aaaaaa;
  display: block;
  position: relative;
  float: left;
  width: 100%;
  height: 50px;
}

ul li input[type="radio"] {
  position: absolute;
  visibility: hidden;
}

ul li label {
  display: block;
  position: relative;
  font-size: 18px;
  line-height: 18px;
  padding: 20px 20px 20px 80px;
  margin: 10px auto;
  height: 10px;
  z-index: 9;
  cursor: pointer;
  transition: all 0.25s linear;
}

ul li:hover label {
  color: #fff;
}

ul li .check {
  color: #3fa9f5;
  display: block;
  position: absolute;
  border: 5px solid #aaaaaa;
  border-radius: 100%;
  height: 25px;
  width: 25px;
  top: 27px;
  left: 25px;
  z-index: 5;
  transition: border 0.25s linear;
  -webkit-transition: border 0.25s linear;
}

li:hover .check {
  border: 5px solid #fff;
}

li .check::before {
  display: block;
  position: absolute;
  content: "";
  border-radius: 100%;
  height: 15px;
  width: 15px;
  margin: auto;
  transition: background 0.25s linear;
  -webkit-transition: background 0.25s linear;
}

input[type="radio"]:checked ~ .check {
  border: 5px solid #3fa9f5;
}

input[type="radio"]:checked ~ .check::before {
  background: #3fa9f5;
}

input[type="radio"]:checked ~ label {
  color: #3fa9f5 !important;
}

@media only screen and (max-width: 768px) {
  ul li label {
  display: block;
  position: relative;
  font-size: 14px;
  line-height: 16px;
  padding: 20px 20px 20px 40px;
  margin: 10px auto;
  height: 10px;
  }

  ul li .check {
    top: 26px;
    left:0px;
  }
}
</style>
